import { Link } from 'react-router-dom';
import type { ISiteConfig } from '../../types';

interface HeroSectionProps {
  config?: ISiteConfig;
  isLoading: boolean;
}

export default function HeroSection({ config }: HeroSectionProps) {
  const hero = config?.hero;

  return (
    <section className="hero-section" id="hero">
      <div className="hero-grid-bg" />

      <div className="hero-inner">
        {/* Left: headline + copy */}
        <div>
          <div className="hero-badge">
            <div className="badge-dot" />
            Apex DeFi Labs Inc. · New York, USA
          </div>

          <h1 className="hero-h1">
            {hero?.headline
              ? hero.headline
              : <>Building the <em>Infrastructure Layer</em> for Next-Generation Capital Markets</>
            }
          </h1>

          <p className="hero-p">
            {hero?.subheadline ||
              'Apex DeFi Labs Inc. is a New York-based technology holding company operating at the intersection of blockchain infrastructure, AI-powered compliance, and regulated capital markets — through three subsidiaries and four category-defining ventures.'}
          </p>

          <div className="hero-actions">
            <Link to={hero?.primaryCtaHref || '/portfolio'} className="btn-gold">
              {hero?.primaryCtaLabel || 'Explore Our Platform →'}
            </Link>
            <Link to={hero?.secondaryCtaHref || '/investor-relations'} className="btn-ghost-dark">
              {hero?.secondaryCtaLabel || 'Investor Relations'}
            </Link>
          </div>
        </div>

        {/* Right: stats card */}
        <div>
          <div className="hero-card">
            <div className="hc-label">Corporate Overview · 2026</div>
            <div className="hc-stat-val">3</div>
            <div className="hc-stat-sub">Operating Subsidiaries</div>
            <div className="hc-items">
              <div className="hc-item">
                <span className="hc-item-l">Brand Ventures</span>
                <span className="hc-item-r gold">4 Active</span>
              </div>
              <div className="hc-item">
                <span className="hc-item-l">Flagship Platform</span>
                <span className="hc-item-r gold">VYASA</span>
              </div>
              <div className="hc-item">
                <span className="hc-item-l">Target Market</span>
                <span className="hc-item-r">$2.1T Reg D Market</span>
              </div>
              <div className="hc-item">
                <span className="hc-item-l">Regulations Covered</span>
                <span className="hc-item-r">Reg D / A+ / CF / S</span>
              </div>
              <div className="hc-item">
                <span className="hc-item-l">Blockchain</span>
                <span className="hc-item-r">Polygon · ERC-1400</span>
              </div>
              <div className="hc-item">
                <span className="hc-item-l">Global Reach</span>
                <span className="hc-item-r">USA + India Ops</span>
              </div>
              <div className="hc-item">
                <span className="hc-item-l">AI Models</span>
                <span className="hc-item-r gold">8 Domain SLMs</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom strip stats */}
      <div className="hero-strip">
        <div className="hs-item">
          <div className="hs-val">$2.1T</div>
          <div className="hs-label">Reg D raised in 2024 — our core market</div>
        </div>
        <div className="hs-item">
          <div className="hs-val">$16T</div>
          <div className="hs-label">Tokenized asset opportunity by 2030 — BCG</div>
        </div>
        <div className="hs-item">
          <div className="hs-val">30K+</div>
          <div className="hs-label">Middle-market issuers underserved today</div>
        </div>
        <div className="hs-item">
          <div className="hs-val">21</div>
          <div className="hs-label">VYASA named product brands</div>
        </div>
      </div>
    </section>
  );
}
